import { render, staticRenderFns } from "./ObjectifsComponent.vue?vue&type=template&id=f816843c&"
import script from "./ObjectifsComponent.vue?vue&type=script&lang=js&"
export * from "./ObjectifsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports